module.exports = __webpack_public_path__ + "static/media/ribbon-specialoffer-de@2x.d64b0268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ribbon-specialoffer-de@2x.png
// module id = 305
// module chunks = 0